import { render, staticRenderFns } from "./BatchManagement.vue?vue&type=template&id=1e5862e6&"
import script from "./BatchManagement.vue?vue&type=script&lang=js&"
export * from "./BatchManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports